(function () {
    const KEYS = ['contrast', 'font', 'spacing', 'motion', 'cursor', 'focus'];
    const html = document.documentElement;

    // hold state info for window
    const state = {
        contrast: localStorage.getItem('a11y-contrast') || 'off',
        font: localStorage.getItem('a11y-font') || 'md',
        spacing: localStorage.getItem('a11y-spacing') || 'off',
        motion: localStorage.getItem('a11y-motion') || 'off',
        cursor: localStorage.getItem('a11y-cursor') || 'off',
        focus: localStorage.getItem('a11y-focus') || 'off',
    };

    // need to apply it all
    function applyAll() {
        html.dataset.a11yContrast = state.contrast;
        html.dataset.a11yFont = state.font;
        html.dataset.a11ySpacing = state.spacing;
        html.dataset.a11yMotion = state.motion;
        html.dataset.a11yCursor = state.cursor;
        html.dataset.a11yFocus = state.focus;
    }

    // util save
    function save() {
        for (const k of KEYS) localStorage.setItem(`a11y-${k}`, state[k]);
    }

    // make run
    function toggle(key) {
        state[key] = state[key] === 'on' ? 'off' : 'on';
        applyAll(); save(); syncUI();
    }

    function setFont(size) { 
        state.font = size; applyAll(); save(); syncUI();
    }

    function syncUI() {
        // toggles
        ['contrast', 'spacing', 'motion', 'cursor', 'focus'].forEach(k => {
            const el = document.getElementById(`a11y-${k}`);
            if (el) el.checked = state[k] === 'on';
        });
        // font buttons
        ['md', 'lg', 'xl', '2xl'].forEach(s => {
            const btn = document.querySelector(`[data-font="${s}"]`);
            if (btn) btn.classList.toggle('active', state.font === s);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        applyAll();

        const toggleBtn = document.getElementById('a11y-toggle');
        const panel = document.getElementById('a11y-panel');

        toggleBtn.addEventListener('click', () => panel.classList.toggle('open'));

        // close on click outside
        document.addEventListener('click', e => {
            if (!panel.contains(e.target) && e.target !== toggleBtn)
                panel.classList.remove('open');
        });

        // wire
        ['contrast', 'spacing', 'motion', 'cursor', 'focus'].forEach(k => {
            document.getElementById(`a11y-${k}`)
                ?.addEventListener('change', () => toggle(k));
        });

        // buttons
        document.querySelectorAll('[data-font]').forEach(btn => {
            btn.addEventListener('click', () => setFont(btn.dataset.font));
        });

        // reset
        document.getElementById('a11y-reset')?.addEventListener('click', () => {
            state.contrast = 'off'; state.font = 'md'; state.spacing = 'off';
            state.motion = 'off'; state.cursor = 'off'; state.focus = 'off';
            applyAll(); save(); syncUI();
        });

        syncUI();
    });

    // appply quick on start
    applyAll();
})();